module.exports = __webpack_public_path__ + "static/media/language.03b8f0dc.svg";